export * from './FaceExpressionNet';
export * from './FaceExpressions';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/faceExpressionNet/index.js
// module id = 1588
// module chunks = 0